import React from 'react';
import { Reveal } from './ui/Reveal';
const steps = ['Un pasaje.', 'Una explicación.', 'Una reflexión.', 'Una aplicación.'];
export function ClosingSection() {
  return <section aria-labelledby="cierre-reflexion" className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-14 text-center" data-id="element-48" data-mp="12su0hpdvgyda">
      <Reveal data-id="element-49" data-mp="xthboz3fxh82">
        <h2 id="cierre-reflexion" className="mx-auto max-w-3xl font-display text-3xl md:text-4xl font-bold uppercase leading-tight text-ink" data-id="element-50" data-mp="xszcbtlhemvx">
          No necesitás entender toda la Biblia hoy
        </h2>
        <p className="mt-3 font-script text-3xl md:text-4xl text-gold" data-id="element-51" data-mp="17q3y3sbf0gc7">
          Necesitás saber por dónde empezar
        </p>
      </Reveal>

      <ul className="mx-auto mt-8 flex max-w-3xl flex-wrap justify-center gap-2" data-id="element-52" data-mp="1hhhtbnwc2tzj">
        {steps.map((step, i) => <Reveal key={step} as="li" delay={i * 0.04} className="rounded-full border border-line bg-surface px-5 py-2.5 text-sm font-medium text-ink" data-id="element-53" data-mp="1viaqkge0s36c" data-mpi={i}>
            {step}
          </Reveal>)}
      </ul>

      <Reveal delay={0.2} data-id="element-54" data-mp="27axaawfr9yu7">
        <p className="mt-8 font-display text-xl md:text-2xl font-bold uppercase tracking-[0.08em] text-gold" data-id="element-55" data-mp="27c8euyh0zamd">
          Y 15 minutos para dar el primer paso
        </p>
      </Reveal>
    </section>;
}